export const CarouselTexts = {
  viewAll: 'مشاهده همه',
};

export const nobatDoctorCarouselGroupKeys = {
  topDoctors: 'InPersonTopDoctors',
  new: 'InPersonBooking',
} as const;

export const verticalDoctorCardTexts = {
  viewOnlineProfile: 'شروع مشاوره',
  viewOfflineProfile: 'رزرو مشاوره',
  inPersonBooking: 'رزرو نوبت',
  viewAll: 'همه',
};

export const TOP_BANNER_REC_ID = 165;

export const bannerType = {
  firstCarouselBanner: 0,
  secondCarouselBanner: 1,
  singleBanner: 2,
  medicineFirstCarouselBanner: 3,
  inPersonBookingCarouselBanner: 4,
  medicalServicesTopBanner: 5,
  medicalServicesSectionBanner: 6,
};

export const SPECIALITY_DATA = [
  {
    id: 71,
    title: 'عمومی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/General.png',
  },
  {
    id: 1,
    title: 'زنان و زایمان',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Women%27s%20menstruation.png',
  },
  {
    id: 54,
    title: 'اطفال',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Pediatrics.png',
  },
  {
    id: 52,
    title: 'داخلی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Domestic.png',
  },
  {
    id: 7,
    title: 'روانشناسی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Psychology.png',
  },
  {
    id: 58,
    title: 'روانپزشکی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Psychiatry.png',
  },
  {
    id: 161,
    title: 'پوست، مو و زیبایی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Skin.png',
  },
  {
    id: 17,
    title: 'ارتوپدی',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Orthopedics.png',
    doctors: 16,
  },
  {
    id: 41,
    title: 'مغز و اعصاب',
    imageUrl:
      'https://s3.ir-thr-at1.arvanstorage.ir/tapsidr/OnlineMedicalConsultation/Specialist/Brain.png',
  },
];

export const SPECIALITY_WITH_LABEL_ID = [71, 1, 54, 7, 52];
